import React, { useState } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const validationSchema = yup.object().shape({
  email: yup
    .string()
    .email("Введите корректный адрес электронной почты")
    .required("Поле почты обязательно"),
  password: yup
    .string()
    .min(6, "Пароль должен содержать не менее 6 символов")
    .required("Поле пароля обязательно"),
});

const DeleteAccount = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const handleDelete = async (data) => {
    console.log("Deleting account with data:", data); // Логируем данные
    try {
      const token = localStorage.getItem("access_token"); // Получаем токен из локального хранилища
      console.log("Authorization token:", token); // Проверяем, что токен есть

      const response = await axios({
        method: "POST",
        url: "https://ades.kg:8083/test/auth/delete", // Укажите правильный путь для удаления аккаунта
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`, // Передаем токен в заголовке
        },
        data: JSON.stringify(data), // Отправляем данные формы
      });

      console.log("Response from server:", response); // Логируем ответ от сервера

      if (response.status === 200) {
        setSuccess("Ваш аккаунт успешно удалён.");
        setError("");
        setIsModalOpen(false); // Закрываем модальное окно после успешного удаления
      }
    } catch (err) {
      console.log("Error during deletion:", err); // Логируем ошибку
      setError(
        err.response?.data?.message || "Произошла ошибка. Попробуйте снова."
      );
      setSuccess(""); // Очищаем сообщение об успехе в случае ошибки
    }
  };

  return (
    <div className="delete-account">
      <h1>Удаление аккаунта</h1>
      <p className="warning">
        <strong>Внимание!</strong> Удаление аккаунта — это необратимый процесс.
        Все данные, связанные с пользователем, также будут удалены безвозвратно.
      </p>

      <form
        className="delete-form"
        onSubmit={handleSubmit((data) => {
          console.log("Form data:", data); // Логируем данные перед отправкой
          setIsModalOpen(true); // Открываем модальное окно
        })}
      >
        <label>
          Почта:
          <input
            type="email"
            placeholder="Введите вашу почту"
            {...register("email")}
          />
          {errors.email && <p className="error">{errors.email.message}</p>}
        </label>
        <label>
          Пароль:
          <input
            type="password"
            placeholder="Введите ваш пароль"
            {...register("password")}
          />
          {errors.password && (
            <p className="error">{errors.password.message}</p>
          )}
        </label>
        <button type="submit" className="confirm-button">
          Подтвердить
        </button>
      </form>
      <button
        type="button"
        className="delete-button"
        onClick={() => setIsModalOpen(true)} // Открыть модалку
      >
        Удалить аккаунт
      </button>

      {error && <p className="error">{error}</p>}
      {success && <p className="success">{success}</p>}

      {isModalOpen && (
        <div className="modal">
          <div className="modal-content">
            <p>Вы уверены, что хотите удалить аккаунт?</p>
            <div className="modal-actions">
              <button
                className="modal-cancel"
                onClick={() => setIsModalOpen(false)} // Закрыть модальное окно
              >
                Отменить
              </button>
              <button
                className="modal-delete"
                onClick={() => {
                  handleDelete(); // Вызываем функцию удаления при подтверждении
                }}
              >
                Удалить
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DeleteAccount;
